<!-- 发票提取单据 -->
<template>
    <div>
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="业务单号">
                <el-input clearable v-model.trim="invoiceExtractData.businessId" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                <el-button type="primary" size="mini" :disabled="returnObj.mainData.length == 0"
                    @click="onSubmit">确定选择</el-button>
            </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="420" size="mini" style="width: 100%" :data="mainData" border stripe
            highlight-current-row :header-cell-style="getHeaderCellStyle" @row-dblclick="dblclick"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column align="center" min-width="150" prop="businessId" label="业务单号"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="150" prop="cateName" label="费用项目"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="totalMoney" label="总金额"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="oldMoney" label="待开票金额"
                :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" min-width="120" prop="createTime" label="登记日期"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.createTime">
                        {{ $common.getLocalTime(scope.row.createTime) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" min-width="120" prop="taxMoney" label="税额"
                :show-overflow-tooltip="true"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "SalesInvoiceExtract",
    components: {},
    data() {
        return {
            opmId: "",
            ormId: "",
            showdetail: true,
            detailData: [],
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            mainData: [],
            searchTermList: [], //检索条件
            returnObj: {//外层对象数据
                mainData: [],
            },
        };
    },

    props: {
        invoiceExtractData: {
            type: Object,
            require: true
        },
    },
    watch: {},
    computed: {},
    mounted() { },
    created() {
        // 处理组件需要的数据
        this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId
        this.getTableMainList()
    },
    methods: {
        onSubmit() {
            this.$emit("invoiceExtractMethods", this.returnObj)
        },
        handleSelectionChange(val) {
            this.returnObj.mainData = val
        },
        searchData() {
            this.returnObj.mainData = []
            this.getTableMainList()
        },
        dblclick(row) {
        },
        // 获取主表格
        async getTableMainList() {
            let params = JSON.parse(JSON.stringify(this.invoiceExtractData))
            let res = await this.$http.sudocumentsextractFeeMaster(params)
            if (res && res.status == 200) {
                this.mainData = res.result; //默认第一条
            } else {
                this.$message({
                    message: res.message,
                    type: 'error'
                });
                this.$emit("invoiceExtractMethods", '')
                return false
            }
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
        getHeaderCellStyleD() {
            return "background: skybule;color: #3e5569";
        },

    },
};
</script>

<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>
